export enum PaperOnboardTypes {
  /** AuthModal - used in paper customization, cart confirmation, and cart */
  AUTH = 'AUTH',
  /** AccessGuestListModal - only used in paper customization */
  GUEST_LIST_ENVELOPE = 'GUEST_LIST_ENVELOPE',
  GUEST_LIST_PLACE_CARD = 'GUEST_LIST_PLACE_CARD',
  GUEST_LIST_THANK_YOU = 'GUEST_LIST_THANK_YOU',
  /** CardsQuickOnboardFlow - only used in paper customization */
  QUICK_ONBOARD = 'QUICK_ONBOARD',
  /** CardsQuickSignupFlow - used in paper customization, cart confirmation, and cart */
  QUICK_SIGNUP = 'QUICK_SIGNUP',
  QUICK_SIGNUP_CHECKOUT = 'QUICK_SIGNUP_CHECKOUT',
  QUICK_SIGNUP_GUEST_LIST = 'QUICK_SIGNUP_GUEST_LIST',
  /** SaveProgressModal - used in paper customization, cart confirmation, and cart */
  SAVE_PROGRESS = 'SAVE_PROGRESS',
  SAVE_PROGRESS_REMOVE = 'SAVE_PROGRESS_REMOVE',
  /** SimpleSignupModal - used in paper customization, cart confirmation, and cart */
  SIMPLE_SIGNUP = 'SIMPLE_SIGNUP',
}
